import utils from '../../../utils/utils';

const now = new Date();
const date = new Date(now);
const monthToDate = date.setDate(now.getDate() - 90);

export const fileQueries = {
    importReportCounts: {
        addCount: true,
        limit: 0,
        text: '',
        initialFilter: {},
        where: {},
    },
};

export const caseQueries = {
    casesReportCounts: {
        addCount: true,
        limit: 0,
        text: '',
        initialFilter: {},
        where: {},
    },
    latestCase: {
        from: 0,
        limit: 1,
        fields: ['registrationDate'],
        sortAsc: false,
        sortField: 'registrationDate',
    },
    recentCases: {
        from: 0,
        limit: 0,
        fields: [
            '_id',
            'registrationDate',
            'physician',
            'status',
            'diagnosticsAwaitingTat',
            'diagnosticsTat',
            'TreatmentPlanningTat',
            'TreatmentAwaitingTat',
        ],
        where: {
            registrationDate: {
                type: 'TEMPORAL',
                gte: `${utils.formatDate(monthToDate, 'YYYY-MM-DD')}`,
                lte: `${utils.formatDate(now, 'YYYY-MM-DD')}`,
            },
        },
    },
};

export const activityQueries = {
    activityCount: {
        addCount: true,
        limit: 0,
        text: '',
        initialFilter: {},
        where: {},
    },
};

export const metricsQueries = (workspaceId: any, year: number) => ({
    // case total queries
    currentYearCases: {
        addCount: true,
        addToGroupBy: [],
        groupBy: [],
        limit: 0,
        sortAsc: false,
        sortField: 'COUNT',
        text: '',
        where: {
            workspaceId: {
                eq: workspaceId,
                type: 'STRING',
            },
            registrationDate: {
                gte: '2024-01-01T05:00:00.000+00:00',
                lte: '2024-12-31T05:00:00.000+00:00',
                type: 'TEMPORAL',
            },
        },
    },
    allYearCasesCount: {
        addCount: true,
        addToGroupBy: [],
        groupBy: ['registrationDate'],
        limit: 0,
        sortAsc: false,
        sortField: 'COUNT',
        text: '',
        where: {
            workspaceId: {
                eq: workspaceId,
                type: 'STRING',
            },
        },
    },
    // diagnostics awaiting queries
    totalDiagnosticsAwaiting: {
        addCount: true,
        addToGroupBy: [],
        groupBy: ['registrationDate'],
        limit: 0,
        sortAsc: false,
        sortField: 'COUNT',
        text: '',
        where: {
            status: {
                eq: 'Diagnostics Awaiting',
                type: 'STRING',
            },
            workspaceId: {
                eq: workspaceId,
                type: 'STRING',
            },
        },
    },
    // diagnostics queries
    totalDiagnostics: {
        addCount: true,
        addToGroupBy: [],
        groupBy: ['registrationDate'],
        limit: 0,
        sortAsc: false,
        sortField: 'COUNT',
        text: '',
        where: {
            status: {
                eq: 'Diagnostics',
                type: 'STRING',
            },
            workspaceId: {
                eq: workspaceId,
                type: 'STRING',
            },
        },
    },
    // treatment planning queries
    totalTreatmentPlanning: {
        addCount: true,
        addToGroupBy: [],
        groupBy: ['registrationDate'],
        limit: 0,
        sortAsc: false,
        sortField: 'COUNT',
        text: '',
        where: {
            status: {
                eq: 'Treatment Planning',
                type: 'STRING',
            },
            workspaceId: {
                eq: workspaceId,
                type: 'STRING',
            },
        },
    },
    // treatment awaiting queries
    totalTreatmentAwaiting: {
        addCount: true,
        addToGroupBy: [],
        groupBy: ['registrationDate'],
        limit: 0,
        sortAsc: false,
        sortField: 'COUNT',
        text: '',
        where: {
            status: {
                eq: 'Treatment Awaiting',
                type: 'STRING',
            },
            workspaceId: {
                eq: workspaceId,
                type: 'STRING',
            },
        },
    },
    // under treatment queries
    totalUnderTreatment: {
        addCount: true,
        addToGroupBy: [],
        groupBy: ['calculateUnderTreatment'],
        limit: 0,
        text: '',
        where: {
            status: {
                eq: 'Treatment',
                type: 'STRING',
            },
            workspaceId: {
                eq: workspaceId,
                type: 'STRING',
            },
        },
    },
    // under treatment procedure queries
    totalUnderTreatmentProcedure: {
        addCount: true,
        addToGroupBy: [],
        groupBy: ['calculateUnderTreatmentProcedure'],
        limit: 0,
        sortAsc: false,
        sortField: 'COUNT',
        text: '',
        where: {
            status: {
                eq: 'Treatment',
                type: 'STRING',
            },
            workspaceId: {
                eq: workspaceId,
                type: 'STRING',
            },
        },
    },
    // under drug treatment queries
    totalUnderDrugTreatment: {
        addCount: true,
        addToGroupBy: [],
        groupBy: ['calculateUnderDrugTreatment'],
        limit: 0,
        sortAsc: false,
        sortField: 'COUNT',
        text: '',
        where: {
            status: {
                eq: 'Treatment',
                type: 'STRING',
            },
            workspaceId: {
                eq: workspaceId,
                type: 'STRING',
            },
        },
    },
    // under drug treatment queries
    totalPostTreatment: {
        addCount: true,
        addToGroupBy: [],
        groupBy: [],
        limit: 0,
        sortAsc: false,
        sortField: 'COUNT',
        text: '',
        where: {
            status: {
                eq: 'Post-treatment',
                type: 'STRING',
            },
            workspaceId: {
                eq: workspaceId,
                type: 'STRING',
            },
        },
    },
});
